import { useDispatch, useSelector } from "react-redux";
import {
  getQuestionsAndAnswers,
  getQuestionsByCategory,
  getSourceSystemContent,
  getSourceSystemIsBranchAppraisal
} from "../../store/selectors/AppraisalSlice";
import {
  getPhotoQuantity,
  getPhotoQuantityMultipleChoice,
  isQuestionsAnswered
} from "../helpers";
import { appraisalSlice } from "../../store/slices/Appraisal";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ConditionalQuestionsFromAssumptionsIds } from "../../data/QuestionData";
import {
  ComponentType,
  QuestionIds,
  questionPresentationContent
} from "../../data/QuestionPresentation";

export function useConditionQuestionsCompactView() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const questions: Question[] = useSelector(
    getQuestionsByCategory("Condition")
  );
  const assumptionQuestions: Question[] = useSelector(
    getQuestionsByCategory("Assumption")
  );

  const extraConditionQuestionsFromAssumptions = assumptionQuestions.filter(
    (question) =>
      ConditionalQuestionsFromAssumptionsIds.find((id) => question.id === id)
  );
  const questionsAndAnswers: ChosenAnswer[] = useSelector(
    getQuestionsAndAnswers
  );
  const isBranchAppraisal = useSelector(getSourceSystemIsBranchAppraisal);
  const { photosRequired } = useSelector(getSourceSystemContent);
  const [isContinueClicked, setIsContinueClicked] = useState<boolean>(false);
  const conditionQuestions: Question[] = [...questions];
  const modificationQuestion = assumptionQuestions.find(
    (question) => question.id === QuestionIds.MODIFICATIONS
  );
  const bodyworkQuestion: Question = conditionQuestions.splice(0, 1)[0] || {};
  const allConditonQuestionsMinusBodyWork = conditionQuestions.concat(
    extraConditionQuestionsFromAssumptions
  );
  const allConditonQuestions = questions.concat(
    extraConditionQuestionsFromAssumptions
  );
  const conditionalQuestionsIds: number[] =
    allConditonQuestionsMinusBodyWork.map((question) => question.id);

  const setPhotosRequiredForConditionQuestions = () => {
    for (const question of allConditonQuestions) {
      const userAnswer = questionsAndAnswers[question.id];
      if (
        questionPresentationContent[question.id].component.type ===
        ComponentType.RADIOANDCHECKBOX
      ) {
        const photoQuantityForMultipleChoiceAnswer =
          getPhotoQuantityMultipleChoice(question.answers, userAnswer);
        dispatch(
          appraisalSlice.actions.setPhotosRequired({
            [question.id]: photoQuantityForMultipleChoiceAnswer
          })
        );
      } else {
        const photoQuantityForAnswer = getPhotoQuantity(
          question.answers,
          userAnswer
        );
        dispatch(
          appraisalSlice.actions.setPhotosRequired({
            [question.id]: photoQuantityForAnswer
          })
        );
      }
    }
  };

  function handleSubmit() {
    setIsContinueClicked(true);
    dispatch(
      appraisalSlice.actions.setConditionalAnswersSubmitted([
        ...conditionalQuestionsIds,
        bodyworkQuestion.id,
        QuestionIds.MODIFICATIONS
      ])
    );
    if (isQuestionsAnswered(allConditonQuestions, questionsAndAnswers)) {
      if (!isBranchAppraisal && photosRequired) {
        setPhotosRequiredForConditionQuestions();
        return navigate("/photos-intro");
      }
      if (isBranchAppraisal && photosRequired) {
        setPhotosRequiredForConditionQuestions();
        navigate("/photos-intro");
      } else {
        if (isBranchAppraisal) return navigate("/initial-offer");
        else return navigate("/estimated-offer");
      }
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }

  return {
    bodyworkQuestion,
    conditionQuestions: allConditonQuestionsMinusBodyWork,
    handleSubmit,
    questionsAndAnswers,
    isContinueClicked,
    modificationQuestion
  };
}
